import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row, Spinner } from 'react-bootstrap';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import ScrollSpy from 'components/base/ScrollSpy';
import LeadDetailsNavbar from 'components/modules/crm/LeadDetailsNavbar';
import LeadDetailsOffcanvas from 'components/modules/crm/LeadDetailsOffcanvas';
import LeadEmails from 'components/modules/crm/LeadEmails';
import LeadAttachments from 'components/modules/crm/LeadAttachments';
import AboutPersonaCard from 'components/cards/AboutPersonaCard';
import ProcesosEnPersonaDetails from 'components/modules/crm/ProcesosEnPersonaDetails';
import PersonaCelulares from 'components/modules/crm/PersonaCelulares';
import { defaultBreadcrumbItems } from 'data/commonData';
import { Persona } from 'data/crm/Personas'; // Importa tu interfaz

const PersonaDetails = () => {
  const { id } = useParams<{ id: string }>();
  const [openOffcanvas, setOpenOffcanvas] = useState(false);
  const [persona, setPersona] = useState<Persona | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000';

  useEffect(() => {
    const fetchPersona = async () => {
      try {
        setLoading(true);
        // Ajusta la URL base a la de tu backend
        const response = await fetch(`${apiUrl}/personas/id/${id}`);
        if (!response.ok) throw new Error('Error al cargar la persona');
        const data: Persona = await response.json();
        setPersona(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error desconocido');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchPersona();
    }
  }, [id]);

  if (loading) {
    return <div className="d-flex justify-content-center p-5"><Spinner animation="border" variant="primary" /></div>;
  }

  if (error || !persona) {
    return <div className="alert alert-danger">Error: {error || 'Persona no encontrada'}</div>;
  }

  return (
    <div>
      <PageBreadcrumb items={defaultBreadcrumbItems} />
      <div className="pb-9">
        <Row className="align-items-center justify-content-between g-3 mb-3">
          <Col xs={12} md="auto">
            <h2 className="mb-0">Detalles de la Persona: {persona.nombres} {persona.apellido}</h2>
          </Col>
        </Row>

        <Row className="g-0 g-md-4 g-xl-6">
          <Col md={5} xl={4} className="d-none d-md-block">
            <div className="sticky-leads-sidebar">
              <div className="lead-details-offcanvas bg-body scrollbar">
                <AboutPersonaCard persona={persona} className="mb-3" />
              </div>
            </div>
          </Col>
          <Col md={7} xl={8}>
            <div className="lead-details-container">
              <ScrollSpy>
{/*                 <LeadDetailsNavbar />
 */}
                <ScrollSpy.Content id="tasks" className="lead-details-scrollspy mb-8">
                  <ProcesosEnPersonaDetails procesos={persona.procesos || []} persona_id={persona.id}  />
                </ScrollSpy.Content>

                <ScrollSpy.Content id="deals" className="lead-details-scrollspy mb-8" minTopValue={150}>
                  <PersonaCelulares numeros={persona.numeros || []} persona_id={persona.id} />
                </ScrollSpy.Content>
{/* 
                <ScrollSpy.Content id="emails" className="lead-details-scrollspy mb-8">
                  <LeadEmails />
                </ScrollSpy.Content>

                <ScrollSpy.Content id="attachments" className="lead-details-scrollspy">
                  <LeadAttachments />
                </ScrollSpy.Content>
                */}
              </ScrollSpy>
             </div>
          </Col>
        </Row>
      </div>
      <LeadDetailsOffcanvas open={openOffcanvas} setOpen={setOpenOffcanvas} />
    </div>
  );

};

export default PersonaDetails;